module.exports = (__webpack_require__(48600))(96540);